import { Component, createRef } from 'react';

import Field from 'Lib/components/form/Field';

import IntegerInput from './IntegerInput';

/**
 * Form field component for integer input
 * @deprecated Use the Trellis Input.Number component instead: https://main--6710219e5989b079dbcc9421.chromatic.com/?path=/docs/components-input-number--docs
 */
class IntegerField extends Component {
	input = createRef();

	handleChange = (e, form, field) => {
		if (this.props.onChange) {
			this.props.onChange(e, form, field);
		}

		if (e.value === '') {
			form.setFieldValue(field.name, null);

			return;
		}

		if (!e) {
			form.setFieldValue(field.name, null);

			return;
		}

		form.setFieldValue(field.name, e.value);
	};

	getInputRef = element => {
		if (element) {
			if (this.props.disable == true) {
				element.readOnly = true;
			}
		}
	};

	renderInput = props => {
		const { form, field } = props;
		const { allowNegative, id, className, readOnly, required, thousandSeparator } = this.props;
		let value = field.value;

		if (value == null) {
			value = '';
		}

		const attrs = {
			allowNegative,
			id,
			className,
			required,
			thousandSeparator,
			value
		};

		if (attrs.className) {
			attrs.className = 'form-control ' + attrs.className;
		} else {
			attrs.className = 'form-control';
		}

		if (readOnly) {
			attrs.className = attrs.className + ' read-only';
		}

		return <IntegerInput {...attrs} getInputRef={this.getInputRef} onChange={e => this.handleChange(e, form, field)} readOnly={readOnly} />;
	};

	render() {
		return <Field {...this.props} render={props => this.renderInput(props)} />;
	}
}

export default IntegerField;
